import { render } from "./EditTaxAddressModal.vue?vue&type=template&id=41af5910&scoped=true"
import script from "./EditTaxAddressModal.vue?vue&type=script&lang=js"
export * from "./EditTaxAddressModal.vue?vue&type=script&lang=js"

import "./EditTaxAddressModal.vue?vue&type=style&index=0&id=41af5910&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41af5910"]])

export default __exports__